import { jsx as _jsx } from "react/jsx-runtime";
import { CheckBoxListField } from '@bos/form';
export const MobilityScopeCheckboxGroupField = ({ mobilityScopesLabelsMap, ...props }) => {
    const mobilityScopesEntries = Object.entries(mobilityScopesLabelsMap);
    const filteredEntries = mobilityScopesEntries.filter(([, label]) => label !== undefined);
    const options = filteredEntries.map(([value, label]) => ({
        value,
        label,
    }));
    return _jsx(CheckBoxListField, { ...props, options: options });
};
